import React from 'react';
import { motion } from 'framer-motion';

const pageVariant = {
  initial: {
    opacity: 1
  },
  animate: {
    opacity: 1,
    transition: {
      duration: 1,
    }
  },
  exit: {
    opacity: 0,
  },
}

export default function AnimatedPage({children}) {
  return (
    <motion.div
      variants={pageVariant}
      initial="initial"
      animate="animate"
      exit="exit"
      className="page d-flex flex-column"
    >
      {children}
    </motion.div>
  )
}
